// extracted by mini-css-extract-plugin
module.exports = {"label":"DatasetPicker_label__2thQ0","dropdown":"DatasetPicker_dropdown__2M9MW"};